import React from 'react';
import styled from 'styled-components';
import { getOptionLabel } from '../../utils';
const StyledLabel = styled.span `
  font-weight: 700;
`;
const Option = ({ option, }) => (React.createElement(StyledLabel, null, getOptionLabel(option)));
export default Option;
